import axios from 'axios';
import {
    GET_ALL_SUB_ENTITIES,
    get_headers,
    GET_ALL_SUB_ENTITIES_BY_ID,
} from '@/utils/constants/constants.js';
import $ from 'jquery';
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import alert_mixin from '@/utils/mixins/alert_mixin';

export default {
  name: 'SubEntities',
  mixins: [alert_mixin, formatting_mixins],
  data: () => ({
    headers: get_headers(),
    entity_type_id: sessionStorage.getItem('entity_type_id'),
    project_id: sessionStorage.getItem('project_id'),
    sub_entities: [],
    sub_entities_by_id: [],
    edit_subentity_id: null,
    edit_subentity_name: '',
    edit_subentity_description: '',
    selected_sub_entities: [],
    table_safe_entity_list: [],
    table_safe_form_list: []    
  }),
  mounted() {
    this.get_all_sub_entities_by_id();
  },
  methods: {
    open_create_subentity_modal() {
      this.destroy_assign_table(); 
      this.get_all_sub_entities();
    },

    async get_all_sub_entities() {
      this.sub_entities = [];
      try {
        let response = await axios.get(GET_ALL_SUB_ENTITIES, {
          headers: this.headers,
        });

        const response_data = response.data;
        if (response_data.status === 'success') {
            this.sub_entities = response_data.data;
            this.transform_sub_entities_data();
        }
        else {
          this.show_error('Error during retrival of sub entities');
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.show_error('Error during the retrival of sub entities:', error.response.data.message);
        }
      }
    },

    destroy_assign_table() {
      const table = $('#assign_subentity_table');
      if ($.fn.DataTable.isDataTable(table)) {
        table.DataTable().clear().destroy();
      }
    },


    transform_sub_entities_data() {
      if (this.sub_entities.length > 0) {
        const TABLE_FORM_DATA = this.sub_entities.map(sub_entity => ({
          id: sub_entity.id,
          name: sub_entity.sub_entity_name,
          description: sub_entity.description || '-',
          selected: false,
        }));

        // this.form_table_headers = Object.keys(TABLE_FORM_DATA[0]);
        this.table_safe_form_list = TABLE_FORM_DATA;

        this.$nextTick(() => {
          this.initialize_assign_table();
        });
      }
    },

    initialize_assign_table() {
      this.$nextTick(() => {
        const table = $('#assign_subentity_table');
        if (table.length === 0 || !table[0].parentNode) return;

        if ($.fn.DataTable.isDataTable(table)) {
          table.DataTable().clear().destroy();
        }

        table.DataTable({
          responsive: true,
          autoWidth: false,
          pageLength: 10,
        });
      });
    },

    async get_all_sub_entities_by_id() {
      this.sub_entities_by_id = [];
      const payload = {
        entity_type_id: this.entity_type_id,
        project_id: this.project_id
      }
      try {
        let response = await axios.get(GET_ALL_SUB_ENTITIES_BY_ID, {
          headers: this.headers,
          params: payload,
        });


        const response_data = response.data;
        if (response_data.status === 'success') {
            this.sub_entities_by_id = response_data.data;
            this.transform_sub_entities_by_id_data();
        }
        else {
          this.show_error('Error during retrival of sub entities');
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.show_error('Error during the retrival of sub entities:', error.response.data.message);
        }
      }
    },

    transform_sub_entities_by_id_data() {
      if (this.sub_entities_by_id.length > 0) {
        const TABLE_FORM_DATA = this.sub_entities_by_id.map(sub_entity => ({
          id: sub_entity.id,
          name: sub_entity.sub_entity_name,
          description: sub_entity.description || '-',
        }));

        // this.form_table_headers = Object.keys(TABLE_FORM_DATA[0]);
        this.table_safe_entity_list = TABLE_FORM_DATA;

        this.$nextTick(() => {
          this.initialize_sub_entity_by_id_table();
        });
      }
    },
    
    initialize_sub_entity_by_id_table() {
      this.$nextTick(() => {
        const table = $('#subentity_by_id_table');
        if (table.length === 0 || !table[0].parentNode) return;

        if ($.fn.DataTable.isDataTable(table)) {
          table.DataTable().clear().destroy();
        }

        table.DataTable({
          responsive: true,
          autoWidth: false,
          pageLength: 10,
        });
      });
    },

  }
};
//